import { render, staticRenderFns } from "./InstanceInvitations.vue?vue&type=template&id=3dea4824&scoped=true&"
import script from "./InstanceInvitations.vue?vue&type=script&lang=js&"
export * from "./InstanceInvitations.vue?vue&type=script&lang=js&"
import style0 from "./InstanceInvitations.vue?vue&type=style&index=0&id=3dea4824&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dea4824",
  null
  
)

export default component.exports